<template>
  <div>
    <section class="section">
      <div
        v-if="hasPastDueSubscription"
        class="container notification is-danger is-light has-text-centered mb-0 past-due-notification"
        style="border-radius: 0"
      >
        <span>
          Your subscription is past due. Please
          <a href="#" @click="onManageSubscription"><strong>Update Payment Method</strong></a>
          .
        </span>
      </div>
    </section>

    <div class="container is-max-hd">
      <div v-if="isManager">
        <div v-if="hasActiveSubscription">
          <SubscriptionChange />
        </div>
        <div v-else>
          <SubscriptionSelect />
        </div>
      </div>
      <div v-else class="column is-three-fifths is-offset-one-fifth">
        <section class="section">
          <div class="box">
            <div class="block">
              <div class="has-text-centered">
                <h1 class="title is-3 has-text-primary">Organization Subscription</h1>
                <p class="block">
                  <strong>{{ organization }}</strong>
                  does not have a current subscription. Your organization manager has been notified.
                </p>

                <p>Please try again later.</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SubscriptionChange from '../components/SubscriptionChange';
import SubscriptionSelect from '../components/SubscriptionSelect';
import request from '../request';

export default {
  name: 'PlanList',
  components: {
    SubscriptionChange,
    SubscriptionSelect,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['organization', 'isManager', 'hasActiveSubscription', 'hasPastDueSubscription']),
  },
  methods: {
    onManageSubscription() {
      this.loading = true;
      request.post('/subscriptions/portal-session').then((resp) => {
        window.location.href = resp.data.redirect_url;
      });
    },
  },
};
</script>

<style scoped>
.past-due-notification {
  position: relative;
  top: -2rem;
  z-index: 20;
}
</style>
